<!--
 * @Author: weiShu
 * @Date: 2026-04-22 10:20:48
 * @LastEditors: weiShu
 * @FilePath: \health-commission-new-2\src\views\course\index.vue
 * @Description: 课程学习 — 顶部轮播与知识页一致（POST /h5/bannerList）
-->
<template>
    <div class="course-page">
        <div class="course-top">
            <van-swipe
                class="top-swipe"
                :autoplay="3000"
                :show-indicators="false"
                @change="onSwipeChange"
            >
                <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                    <div class="top-banner" :style="{ backgroundImage: 'url(' + item + ')' }"></div>
                </van-swipe-item>
                <div class="custom-indicator" slot="indicator">
                    <span
                        v-for="(item, index) in bannerList"
                        :key="`indicator-${index}`"
                        :class="['indicator-dot', { active: index === currentSwipe }]"
                    ></span>
                </div>
            </van-swipe>
        </div>

        <div class="course-content">
            <div class="section-title">课程类别</div>
            <div class="category-card">
                <div class="category-grid">
                    <div
                        class="category-item"
                        v-for="(item, index) in categoryList"
                        :key="index"
                        @click="goCourseType(item)"
                    >
                        <div class="category-icon">
                            <img
                                :src="item.img"
                                :alt="item.tname || '分类图标'"
                                class="category-img"
                            />
                        </div>
                        <div class="category-name">{{ item.tname }}</div>
                    </div>
                </div>
            </div>

            <div class="section-title section-gap">课程推荐</div>
            <div class="recommend-card">
                <van-list
                    v-model="recommendLoading"
                    :finished="recommendFinished"
                    finished-text="没有更多了"
                    @load="loadRecommendList"
                >
                    <div
                        class="recommend-item"
                        v-for="(item, index) in recommendList"
                        :key="item.id || index"
                        @click="goCourseDetail(item)"
                    >
                        <div class="recommend-cover-wrap">
                            <span
                                class="ribbon"
                                :class="item.compulsory ? 'ribbon-required' : 'ribbon-elective'"
                            >
                                {{ item.compulsory ? '必修' : '选修' }}
                            </span>
                            <div
                                class="recommend-cover"
                                :style="
                                    item.cover
                                        ? { backgroundImage: 'url(' + item.cover + ')' }
                                        : null
                                "
                            ></div>
                        </div>
                        <div class="recommend-body">
                            <div class="recommend-title">{{ item.title }}</div>
                            <div class="recommend-footer">
                                <span class="recommend-date">{{ item.createTime }}</span>
                                <span
                                    :class="['read-tag', item.isTrain === '已培训' ? 'read' : 'unread']"
                                >
                                    <img class="tag-icon" :src="seeIcon" alt="">
                                    <span class="tag-text">{{ item.isTrain || '未培训' }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
import { getBannerList, getCourseTypeList, getCourseList, getElectiveNum } from '@/api/index.js';

const defaultBannerImg = require('@/assets/image/evaluation-top-bg.png');

export default {
    name: 'CourseIndex',
    data() {
        return {
            currentSwipe: 0,
            seeIcon: require('@/assets/image/see-icon.png'),
            bannerList: [defaultBannerImg],
            categoryList: [],
            recommendList: [],
            recommendLoading: false,
            recommendFinished: false,
            recommendPageNum: 1,
            recommendPageSize: 20
        };
    },
    created() {
        this.loadBannerList();
        this.loadCourseTypeList();
        this.loadElectiveNumNotice();
    },
    methods: {
        loadElectiveNumNotice() {
            getElectiveNum()
                .then(res => {
                    const electiveNum = Number(res && res.data);
                    if (Number.isNaN(electiveNum) || electiveNum <= 0) {
                        return;
                    }
                    this.$dialog.alert({
                        title: '提示',
                        message: `本次课程学习需要完成所有必修课程和至少${electiveNum}门选修课程才可完成培训参与测评考试。`
                    });
                })
                .catch(() => {});
        },
        loadBannerList() {
            getBannerList({
                type: '课程学习'
            })
                .then(res => {
                    const records = Array.isArray(res?.data?.records) ? res.data.records : [];
                    const urls = records.map(item => item.img).filter(Boolean);
                    this.bannerList = urls.length > 0 ? urls : [defaultBannerImg];
                })
                .catch(() => {
                    this.bannerList = [defaultBannerImg];
                });
        },
        loadCourseTypeList() {
            getCourseTypeList({
                pageNum: 1,
                pageSize: 9999
            })
                .then(res => {
                    this.categoryList = res?.data?.records || [];
                })
                .catch(() => {
                    this.categoryList = [];
                });
        },
        loadRecommendList() {
            getCourseList({
                pageNum: this.recommendPageNum,
                pageSize: this.recommendPageSize,
                recommend: true
            })
                .then(res => {
                    const data = res?.data || {};
                    const list = data.records || [];
                    this.recommendList = this.recommendList.concat(list);

                    const total = Number(data.total);
                    if (!Number.isNaN(total) && total >= 0) {
                        this.recommendFinished = this.recommendList.length >= total;
                    } else {
                        this.recommendFinished = list.length < this.recommendPageSize;
                    }

                    this.recommendPageNum += 1;
                })
                .catch(() => {
                    this.recommendFinished = true;
                })
                .finally(() => {
                    this.recommendLoading = false;
                });
        },
        onSwipeChange(index) {
            this.currentSwipe = index;
        },
        goCourseDetail(item) {
            this.$router.push({ name: 'courseDetail', query: { id: item.id } });
        },
        goCourseType(item) {
            this.$router.push({
                name: 'courseTypeList',
                query: {
                    typeId: item.id,
                    typeName: item.tname || item.typeName || item.name || '分类名称'
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.course-page {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

.course-top {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 100%;
    height: 300px;
    background: #ffffff;

    .top-swipe {
        width: 100%;
        height: 300px;
        overflow: hidden;
        position: relative;
    }

    .top-banner {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
    }

    .custom-indicator {
        position: absolute;
        left: 50%;
        bottom: 90px;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .indicator-dot {
        width: 30px;
        height: 4px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.55);
        transition: all 0.2s ease;
    }

    .indicator-dot.active {
        background: #ffffff;
    }
}

.course-content {
    flex: 1;
    padding: 20px 15px 80px;
    margin-top: -80px;
    position: relative;
    z-index: 2;
    background: linear-gradient(to bottom, #c2e5eb, #eef4f5);
    border-radius: 20px 20px 0 0;
}

.section-title {
    font-size: 16px;
    font-weight: 700;
    color: #333;
    margin-bottom: 12px;
}

.section-gap {
    margin-top: 20px;
}

.category-card {
    background: #fff;
    border-radius: 12px;
    padding: 16px 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.category-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px 8px;
}

.category-item {
    text-align: center;
    cursor: pointer;
}

.category-icon {
    width: 48px;
    height: 48px;
    margin: 0 auto 8px;
    border-radius: 10px;
    background: linear-gradient(145deg, #5ec9d4, #3ba8bc);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(59, 168, 188, 0.35);
}

.category-play {
    font-size: 22px;
    color: #fff;
}

.category-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
}

.category-name {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
    line-height: 1.2;
}

.category-desc {
    font-size: 11px;
    color: #9c9c9c;
    line-height: 1.35;
    padding: 0 2px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.recommend-card {
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.recommend-item {
    display: flex;
    gap: 12px;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;

    &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
    }
}

.recommend-cover-wrap {
    position: relative;
    width: 110px;
    height: 80px;
    flex-shrink: 0;
}

.recommend-cover {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    background: linear-gradient(120deg, #89d9f7, #6b8cff);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.ribbon {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
    padding: 3px 18px 3px 6px;
    transform: rotate(-12deg) translate(-4px, 4px);
    transform-origin: left top;
    line-height: 1.2;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.ribbon-required {
    background: linear-gradient(135deg, #ff9a4a, #ff6633);
}

.ribbon-elective {
    background: linear-gradient(135deg, #7b8cff, #5a6fd8);
}

.recommend-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.recommend-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    line-height: 1.35;
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
}

.recommend-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.recommend-date {
    font-size: 11px;
    color: #9c9c9c;
}

.read-tag {
    display: inline-flex;
    align-items: center;
    height: 24px;
    border-radius: 4px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.read-tag.read {
    background-image: url('~@/assets/image/read-icon.png');
}

.read-tag.unread {
    background-image: url('~@/assets/image/unread-icon.png');
}

.tag-icon {
    width: 24px;
    height: 24px;
    padding: 5px;
    box-sizing: border-box;
    object-fit: contain;
    flex-shrink: 0;
}

.tag-text {
    padding: 0 8px;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
}

.read .tag-text {
    color: #46CCDC;
}

.unread .tag-text {
    color: #FF7A00;
}
</style>
